import { Button, ErrorMessage, Spinner } from "../../../../../widgets";
import { ButtonProperties, useButtonProperties } from "./ButtonProperties";
import { ControlType, FetchStatus, IEntity } from "../../../../../base/types";

import { DraftButtonComponent } from "./DraftButtonComponent";
import { FC } from "react";
import { IControlAttributes } from "../../../../../base/models";
import { Registry } from "../../../../../base/register";
import { useFormikContext } from "formik";

export const ButtonComponent: FC<IControlAttributes> = ({
    className, children, props, designerMode
}) => {
    const { status, properties, error } = useButtonProperties(props);
    const { isSubmitting } = useFormikContext<IEntity>() || {}

    switch (status) {
        case FetchStatus.Idle: return <></>
        case FetchStatus.Loading: return <Spinner show={true} />
        case FetchStatus.Error: return <ErrorMessage message={error} />
    }

    return <Button
        {...properties}
        className={className}
        iconClassName="me-1"
        disabled={properties?.disabled || isSubmitting}
    >
        {children}
    </Button>
}

Registry.addControl({
    id: "617c1a86-4327-4a1f-953b-0d0cc3ec4555",
    name: "Button",
    type: ControlType.Button,
    properties: ButtonProperties,
    component: ButtonComponent,
    draftComponent: DraftButtonComponent
})
